import { Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box } from "@mui/system";
import { ReactElement } from "react";
import { Outlet, useParams } from "react-router-dom";
import ProjectsList from "../hooks/project/projectsList/projectsList";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function ProjectsRoute(): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const params = useParams();

  if (params.id)
    return (
      <Box sx={{ flex: 1, display: "flex" }}>
        <Outlet />
      </Box>
    );

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        height: "100%",
        background: "none",
        p: 2,
        gap: 2,
      }}
    >
      <Paper
        sx={{
          flexGrow: 1,
          border: "none",
          display: "flex",
          background: "red",
          flexDirection: "column",
          maxHeight: "calc(100vh - 92px)",
        }}
      >
        <ProjectsList />
      </Paper>
    </Box>
  );
}
